"use client";

import React from "react";
import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, ShieldCheck, Activity, Wrench } from "lucide-react";
const steps = [{
  title: "Sopralluogo tecnico",
  description: "Analisi preliminare dell'impianto. Il vero problema è dentro i tubi: i grassi e gli oli non restano solo sulla cappa, ma vengono aspirati e si depositano in profondità nelle tubazioni."
}, {
  title: "Valutazione componenti",
  description: "Esame dettagliato di cappa, filtri, plenum, tubi, condotti e ventilatori. Trattare solo la parte visibile esterna non è sufficiente per garantire la sicurezza dell'impianto."
}, {
  title: "Ispezione visiva o video",
  description: "Verifica interna delle canalizzazioni. I condotti di estrazione possono svilupparsi per diversi metri, presentando curve e tratti verticali impossibili da raggiungere manualmente."
}, {
  title: "Analisi delle criticità interne",
  description: "Identificazione degli accumuli di vapori condensati e grassi che riducono la capacità di aspirazione, sovraccaricano i ventilatori e aumentano drasticamente il rischio di incendio."
}, {
  title: "Piano operativo",
  description: "Definizione della strategia di intervento specialistico, programmando le fasi di lavoro per minimizzare il fermo impianto e garantire la massima efficienza della riqualificazione."
}, {
  title: "Intervento con robot dedicati",
  description: "Utilizzo di robot avanzati, ugelli specifici e spazzole rotanti che avanzano all'interno della canalizzazione, permettendo di intervenire efficacemente sulle superfici interne non accessibili."
}, {
  title: "Verifica finale",
  description: "Controllo accurato post-intervento per assicurare la completa rimozione dei depositi interni, ripristinando le condizioni igienico-funzionali ottimali dell'intero sistema di estrazione."
}, {
  title: "Report fotografico prima/dopo",
  description: "Rilascio di documentazione tecnica dettagliata che certifica lo stato dell'impianto prima e dopo l'intervento, garantendo trasparenza e conformità normativa."
}];
const sectors = ["Hotel", "Ristoranti", "Mense", "Supermercati", "Gastronomie", "Cucine centralizzate", "Industrie alimentari", "Strutture sanitarie", "RSA"];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};
export default function Metodooperativoaera() {
  return <section id="metodooperativoaera" className="bg-background relative overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_100%)]" />

      <div className="mx-auto max-w-7xl px-6 relative z-10">
        {}
        <div className="mb-20 max-w-3xl">
          <div className="mb-4 flex items-center gap-2 text-accent">
            <Activity className="size-5" />
            <span className="font-mono text-sm font-semibold uppercase tracking-wider">
              Protocollo Operativo
            </span>
          </div>
          <h2 className="font-default text-foreground mb-6 text-4xl font-bold tracking-tight md:text-5xl">
            Cappe professionali e tubazioni di estrazione cucina
          </h2>
          <p className="text-secondary-foreground/80 text-lg leading-relaxed md:text-xl">
            Interventi specialistici su cappe inox, filtri, plenum, tubi di
            estrazione, condotti interni, curve, tratti verticali, ventilatori e
            componenti soggetti ad accumuli di grassi, oli e vapori condensati.
          </p>
        </div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: "-100px"
      }} className="relative mx-auto max-w-5xl">
          {}
          <div className="absolute bottom-0 left-4 top-0 w-px bg-accent/20 md:left-[8.5%]">
            {}
            <div className="absolute left-0 top-0 h-full w-full">
              {Array.from({
              length: 40
            }).map((_, i) => <div key={i} className="absolute left-0 h-px w-2 bg-accent/20" style={{
              top: `${i / 40 * 100}%`
            }} />)}
            </div>
          </div>

          <div className="space-y-16 md:space-y-24">
            {steps.map((step, index) => <motion.div key={index} variants={itemVariants} data-index={index} className="relative grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-12">
                {}
                <div className="relative flex items-start pl-12 md:col-span-2 md:justify-end md:pl-0 md:pr-8">
                  {}
                  <div className="absolute left-4 top-6 h-px w-8 bg-accent md:left-auto md:right-0 md:w-full" />
                  {}
                  <div className="absolute left-[14px] top-[22px] size-2 rounded-lg bg-accent md:left-auto md:right-[-4px]" />
                  
                  <span className="font-mono text-accent mt-1 text-4xl font-light tracking-tighter md:text-5xl">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                {}
                <div className="md:col-span-10">
                  <Card className="border-border/50 bg-card shadow-md rounded-md transition-all duration-300 hover:shadow-lg hover:border-accent/30">
                    <CardContent className="p-8 md:p-10">
                      <h3 className="font-default text-foreground mb-4 text-2xl font-semibold">
                        {step.title}
                      </h3>
                      <p className="text-secondary-foreground/80 text-base leading-relaxed md:text-lg">
                        {step.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-32 rounded-md bg-secondary p-8 md:p-12 shadow-xl">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:items-center">
            <div>
              <div className="mb-6 flex items-center gap-3">
                <ShieldCheck className="text-accent size-8" />
                <h3 className="font-default text-secondary-foreground text-3xl font-bold">
                  Sicurezza ed efficienza
                </h3>
              </div>
              <p className="text-secondary-foreground/80 mb-8 text-lg leading-relaxed">
                Vuoi sapere cosa c’è davvero dentro i tubi della tua cappa? Aera
                esegue sopralluoghi tecnici su cappe professionali e tubazioni
                di estrazione cucina, con ispezione, intervento interno e
                documentazione finale.
              </p>
              <Button asChild size="lg" className="rounded-md bg-accent text-accent-foreground hover:bg-accent/90">
                <Link to="/TechnicalInspectionPage">
                  Richiedi sopralluogo tecnico
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>

            <div className="border-border/20 lg:border-l lg:pl-12">
              <div className="mb-6 flex items-center gap-2 text-secondary-foreground">
                <Wrench className="size-5" />
                <h4 className="font-default text-xl font-semibold">
                  Settori operativi serviti
                </h4>
              </div>
              <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                {sectors.map((sector, i) => <li key={i} data-index={i} className="flex items-center gap-2 text-secondary-foreground/80">
                    <div className="size-1.5 rounded-lg bg-accent" />
                    <span className="font-medium">{sector}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}